<template>
  <div>
    <div class="header">
      <h4 class="normal" v-html="this.$store.getters['auth/getResource']('acc_ord_person')"></h4>
    </div>
    <el-form :model="form" label-position="top">
      <el-form-item label prop="name" :error="errors.name">
        <el-input v-model="form.name" :placeholder="this.$store.getters['auth/getResource']('reg_name')" :disabled="disabled"></el-input>
      </el-form-item>
      <el-form-item label prop="email" :error="errors.email">
        <el-input v-model="form.email" type="email" :placeholder="this.$store.getters['auth/getResource']('reg_email')" :disabled="disabled"></el-input>
      </el-form-item>
      <el-form-item label prop="phone" :error="errors.phone">
        <el-input v-model="form.phone" :placeholder="this.$store.getters['auth/getResource']('reg_phone')" :disabled="disabled"></el-input>
      </el-form-item>
      <template v-if="payoption">
        <el-form-item :label="this.$store.getters['auth/getResource']('txt_pay_option')" :error="errors.pay_opt">
        <el-radio-group v-model="form.pay_opt">
          <el-radio :label="1">{{this.$store.getters['auth/getResource']('pay_option_1')}}</el-radio>
          <el-radio :label="2">{{this.$store.getters['auth/getResource']('pay_option_2')}}</el-radio>
        </el-radio-group>
        </el-form-item>
      </template>
    </el-form>
  </div>
</template>
<script>
export default {
  computed: {
    form: {
      get() {
        return this.$store.state.orderUserForm;
      },
      set(data) {
        this.$store.commit('setOrderUserForm', data);
      },
    },
    errors: {
      get() {
        return this.$store.state.orderUserFormErrors;
      },
    },
    disabled() {
      if (this.$store.getters['auth/getUserData'].id) {
        return true;
      }
      return false;
    },
    payoption(){
      return this.$store.getters['auth/getUserData'].env;
    }
  },
}
</script>
